import { useLoaderData } from 'react-router';
import { dsClass } from '../../common/constants/dsClasses.js';
import { paths } from '../../common/constants/pathVariables.js';
import {
  contactInfoMsg,
  corporateCustomersMsg,
  createNewMessageMsg,
  leaveMessageMsg,
  t,
} from '../../common/i18n/index.js';
import { useAuth } from '../../public/site/AuthProvider';
import { BreadCrumbs } from '../BreadCrumbs/BreadCrumbs.js';
import { NewSupportCase } from '../NewSupportCase/NewSupportCase.js';
import type { SupportCaseFormLoaderData } from '../../common/loaders';

import './NewSupportCasePublic.scss';

export const NewSupportCasePublic = () => {
  const { billChannels } = useLoaderData() as SupportCaseFormLoaderData;
  const { isAuthenticated } = useAuth();

  return (
    <div className="of-new-support-case-public">
      <BreadCrumbs
        breadCrumbPaths={[
          { name: t.KBLX(corporateCustomersMsg), path: '/' },
          { name: t.GJS9(contactInfoMsg), path: paths.CONTACT_INFO },
          { name: t.WVNV(leaveMessageMsg), path: paths.CONTACT },
          { name: t.J7JN('Create a new message') },
        ]}
      />
      <h1 className={dsClass.TEXT_ALIGN_CENTER}>{t.WVNV('Leave a message')}</h1>
      <NewSupportCase selfService={isAuthenticated} title={t.J7JN(createNewMessageMsg)} billChannels={billChannels} />
    </div>
  );
};
